/**
 * api.js — Central API URL resolver
 *
 * Mobile (Capacitor): served from http://localhost → hostname = "localhost"
 *   → use PC's actual LAN IP so both Emulator and real device can reach backend
 * Browser dev: hostname = actual LAN IP (e.g. 192.168.1.100) → use as-is
 */

const BACKEND_PORT = 9082;
const PC_LAN_IP = '192.168.1.100';

const hostname = window.location.hostname;
const isProd = hostname !== 'localhost' && hostname !== '127.0.0.1';

export const API_URL = isProd
  ? 'https://api.qeduvo.com'
  : `http://${resolveApiHost()}:${BACKEND_PORT}`;

export const API = API_URL; // alias for files using `API`

export const WS_URL = isProd
  ? 'wss://api.qeduvo.com/community'
  : `ws://${resolveApiHost()}:9083`;

function resolveApiHost() {
  const hostname = window.location.hostname;

  // Capacitor native app serves content from "localhost"
  // Browser dev server uses the actual LAN IP directly
  if (!hostname || hostname === 'localhost' || hostname === '127.0.0.1') {
    return PC_LAN_IP;
  }

  return hostname;
}

export default API_URL;
